var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { dynamicSort } from '@/shared/utils/dynamicSort';
export var Scope = function (_a) {
    var title = _a.title, scopes = _a.scopes, onScopeToggled = _a.onScopeToggled, selectedScopes = _a.selectedScopes, disabled = _a.disabled;
    var selected = function (scope) { return selectedScopes.indexOf(scope) > -1; };
    return (_jsxs("div", __assign({ className: "scopes-set" }, { children: [_jsx("h5", { children: title }), _jsx("div", __assign({ className: "scopes" }, { children: scopes.sort(dynamicSort('displayName')).map(function (scope) { return (_jsxs("div", __assign({ className: "scope" }, { children: [_jsx("input", { disabled: disabled, checked: selected(scope.name), onChange: function () { return onScopeToggled(scope.name); }, type: "checkbox", id: scope.name, title: scope.description }), _jsx("label", __assign({ htmlFor: scope.name, title: scope.description }, { children: scope.displayName }))] }), scope.name)); }) }))] })));
};
